import React, { memo, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createUseStyles, Text, Tabs, SelectWrapper, Select } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'SectionTabs');
function SectionTabs(_ref) {
  let {
    onChange,
    onChangeShrinked,
    activeTab,
    activeShrinkedTab,
    shrinkedTabs,
    tabs = []
  } = _ref;
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const shrinkedTab = classnames(classes.shrinkedTab, {
    [classes.activeShrinkedTab]: activeShrinkedTab
  });
  const newSelectRef = useRef(null);
  const getSelectRef = ref => {
    if (ref) newSelectRef.current = ref;
  };
  const getIsOpen = isOpen => {
    if (newSelectRef && newSelectRef.current) {
      if (isOpen) setTimeout(() => {
        newSelectRef.current.focus();
      }, 50);
    }
  };
  const shrinkedTabSelect = {
    select: classes.shrinkedTabSelect
  };
  const postComponent = shrinkedTabs && /*#__PURE__*/React.createElement(SelectWrapper, {
    getIsOpen: getIsOpen,
    customOptions: /*#__PURE__*/React.createElement(Select, {
      placeholder: t('cfm_action_search'),
      onChange: onChangeShrinked,
      options: shrinkedTabs,
      value: activeShrinkedTab,
      classes: shrinkedTabSelect,
      getRef: getSelectRef,
      useMenuPortal: false,
      menuPosition: "absolute",
      isFullWidth: true,
      highlightMatch: true,
      forceMenuIsOpen: true,
      autoFocus: true
    })
  }, /*#__PURE__*/React.createElement(Text, {
    className: [classes.shrinkedTabText, activeShrinkedTab ? activeShrinkedTab.label : t('cfm_label_select_other_table')],
    type: "body"
  }, activeShrinkedTab ? activeShrinkedTab.label : t('cfm_label_select_other_table')));
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Tabs, {
    className: classes.tabsRoot,
    activeKey: activeTab,
    tabs: tabs,
    onChange: onChange,
    postComponent: postComponent,
    classes: {
      root: classes.root,
      postComponent: shrinkedTab
    }
  }));
}
process.env.NODE_ENV !== "production" ? SectionTabs.propTypes = {
  onChange: PropTypes.func,
  onChangeShrinked: PropTypes.func,
  activeTab: PropTypes.string,
  activeShrinkedTab: PropTypes.shape({
    label: PropTypes.string,
    valu: PropTypes.string
  }),
  tabs: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string
  })),
  shrinkedTabs: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    valu: PropTypes.string
  }))
} : void 0;
export default /*#__PURE__*/memo(SectionTabs);